import { useEffect, useState } from 'react'

const STATUS_MESSAGES = [
  'Thinking…',
  'Working on it…',
  'Looking things up…',
  'Processing…',
  'Writing response…',
  'Analyzing…',
  'Reviewing context…',
  'Gathering information…',
  'Reasoning through this…',
  'Checking details…',
  'Putting it together…',
  'Figuring this out…',
  'Considering options…',
  'Reading context…',
  'Almost there…',
]

const DELAY_BEFORE_CYCLING_MS = 4000

const getRandomMessage = (exclude: string) => {
  const options = STATUS_MESSAGES.filter((message) => message !== exclude)
  return options[Math.floor(Math.random() * options.length)]
}

const getRandomInterval = () => 3000 + Math.random() * 1000

export const useProcessingStatus = (isLoading: boolean) => {
  const [status, setStatus] = useState(STATUS_MESSAGES[0])

  useEffect(() => {
    setStatus(STATUS_MESSAGES[0])

    if (!isLoading) return

    let timeoutId: NodeJS.Timeout | undefined = undefined
    const cycle = () => {
      setStatus((prevStatus) => getRandomMessage(prevStatus))
      timeoutId = setTimeout(cycle, getRandomInterval())
    }

    timeoutId = setTimeout(cycle, DELAY_BEFORE_CYCLING_MS)

    return () => clearTimeout(timeoutId)
  }, [isLoading])

  return status
}
